import React from 'react'

import NewGameButton from './NewGameButton'
import Game from './Game'
import SavedGamesList from './SavedGamesList'

import { Space } from 'antd'

const Home = () => {
  return (
    <Space
      direction='vertical'
      size='large'
      style={{ display: 'flex' }}
    >

      <Game />

      <NewGameButton />

      <SavedGamesList />

    </Space>
  )
}

export default Home
